/* ══════════════════════════════════════════════════════════════════════════
   Homepage — shop-by mode switcher, bestseller grid, set add, newsletter.
   Every product surface reads the shared 19-SKU catalogue, so one catalogue
   edit updates every band.
   ══════════════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';
  var SQ = window.SQ;

  var byPop = SQ.ALL.slice().sort(function (a, b) {
    return SQ.CATALOGUE[b].pop - SQ.CATALOGUE[a].pop;
  });

  /* ═══════════════  shop by … (01): two browse modes  ═══════════════
     Dual-path browsing per the homepage framework. "Shape" is the form
     factor; "Feel" is the surface (smooth / textured / glitter), which is
     the thing people actually pick a squishy for. Both axes are honest:
     shape and texture are visible in every photo. No hardness axis until
     the client supplies real firmness data. */
  var MODES = [
    { id: 'shape', label: 'Shape', map: SQ.CATS,  key: 'cat' },
    { id: 'feel',  label: 'Feel',  map: SQ.FEELS, key: 'feel' }
  ];
  var mode = MODES[0];

  /* Each group leads with ONE filled photograph — a hand actually holding or
     crushing a product from that group, edge to edge. Hand-picked rather than
     derived so the three tiles in a mode never land on the same colour field
     (peach / deep green / pink, then lilac / yellow / teal). Every product
     shown genuinely belongs to the group it fronts. */
  var GROUP_HERO = {
    'cat:food': 'ice-pop', 'cat:shapes': 'marble', 'cat:creatures': 'bear',
    'feel:smooth': 'ice-cube', 'feel:textured': 'lemon-drop', 'feel:glitter': 'heart'
  };

  var elModes = document.querySelector('[data-shop-modes]');
  var elGroups = document.querySelector('[data-shop-groups]');

  function groupsFor(m) {
    return Object.keys(m.map).map(function (k) {
      var ids = SQ.ALL.filter(function (id) { return SQ.CATALOGUE[id][m.key] === k; })
        .sort(function (a, b) { return SQ.CATALOGUE[b].pop - SQ.CATALOGUE[a].pop; });
      return { key: k, label: m.map[k], ids: ids };
    }).filter(function (g) { return g.ids.length; });
  }

  function renderModes() {
    if (!elModes) return;
    elModes.innerHTML = MODES.map(function (m) {
      return '<button class="mode-tab" data-mode="' + m.id + '" aria-pressed="' +
        (m.id === mode.id) + '">' + m.label + '</button>';
    }).join('');
  }

  function renderGroups() {
    if (!elGroups) return;
    elGroups.innerHTML = groupsFor(mode).map(function (g) {
      var heroId = GROUP_HERO[mode.key + ':' + g.key] || g.ids[0];
      return '<a class="shop-group" href="' + SQ.collectionUrl(mode.key + '=' + g.key) + '">' +
        '<img class="sg-photo" src="' + SQ.life(heroId) + '" alt="' +
          SQ.CATALOGUE[heroId].name + ' held in one hand" loading="lazy">' +
        '<div class="sg-veil" aria-hidden="true"></div>' +
        '<div class="sg-body">' +
          '<strong>' + g.label + '</strong>' +
          '<em>' + g.ids.length + ' shape' + (g.ids.length === 1 ? '' : 's') + '</em>' +
          '<span class="sg-cta">Browse ' + g.label.toLowerCase() + ' →</span>' +
        '</div>' +
      '</a>';
    }).join('');
  }

  if (elModes) {
    elModes.addEventListener('click', function (e) {
      var b = e.target.closest('[data-mode]');
      if (!b) return;
      var next = MODES.filter(function (m) { return m.id === b.getAttribute('data-mode'); })[0];
      if (!next || next.id === mode.id) return;
      mode = next;
      renderModes();
      elGroups.classList.remove('is-in');
      /* one frame out, then in: a swap you can feel without a scroll trigger */
      requestAnimationFrame(function () {
        renderGroups();
        requestAnimationFrame(function () { elGroups.classList.add('is-in'); });
      });
    });
  }

  /* ─────────────────────────  bestsellers (02)  ────────────────────────── */
  /* The first few rail cards are on screen the moment the band is, so they
     load eagerly. Lazy tiles in the first viewport render as blank holes. */
  function card(p, i) {
    return '<div class="pcard pcard--sm">' +
      '<div class="pcard-bar" style="background:' + p.bar + '"></div>' +
      (p.badge ? '<span class="pcard-badge">' + p.badge + '</span>' : '') +
      '<a class="pcard-media" href="' + SQ.urlOf(p.id) + '" aria-label="View ' + p.name + '">' +
        '<img src="' + SQ.photo(p.id, 1) + '" alt="' + p.name + ' packshot"' +
          (i < 9 ? '' : ' loading="lazy"') + ' width="800" height="800">' +
      '</a>' +
      '<div class="pcard-body">' +
        '<div class="pcard-row">' +
          '<a class="pcard-title" href="' + SQ.urlOf(p.id) + '"><strong class="pcard-name">' + p.name + '</strong></a>' +
          '<span class="pcard-no">NO. ' + p.no + '</span>' +
        '</div>' +
        '<div class="pcard-row" style="align-items:center">' +
          '<span class="rating"><span class="star">★</span> ' + p.rating + ' <i>(' + p.count + ')</i></span>' +
          '<span class="pcard-price"><strong class="price-now">' + SQ.fmt(SQ.UNIT) + '</strong></span>' +
        '</div>' +
        '<button class="kc kc--light kc--sm kc-block" data-add="' + p.id + '">Add to cart</button>' +
      '</div>' +
    '</div>';
  }

  /* ─────────────────────────  rail scroll control  ──────────────────────── */
  function mountRail(rail) {
    var track = document.querySelector('[data-rail-track]');
    var thumb = document.querySelector('[data-rail-thumb]');
    var prev = document.querySelector('[data-rail-prev]');
    var next = document.querySelector('[data-rail-next]');
    if (!track || !thumb) return;

    function sync() {
      var max = rail.scrollWidth - rail.clientWidth;
      var frac = rail.clientWidth / rail.scrollWidth;
      thumb.style.width = Math.max(12, frac * 100) + '%';
      thumb.style.left = (max <= 0 ? 0 : (rail.scrollLeft / max) * (100 - Math.max(12, frac * 100))) + '%';
      if (prev) prev.disabled = rail.scrollLeft < 4;
      if (next) next.disabled = rail.scrollLeft > max - 4;
    }
    /* one card plus its gap, so a click always lands on a card edge */
    function step() {
      var c = rail.querySelector('.pcard');
      return c ? c.getBoundingClientRect().width + 12 : 240;
    }
    function nudge(dir) { rail.scrollBy({ left: dir * step() * 2, behavior: 'smooth' }); }

    rail.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    if (prev) prev.addEventListener('click', function () { nudge(-1); });
    if (next) next.addEventListener('click', function () { nudge(1); });
    track.addEventListener('click', function (e) {
      var r = track.getBoundingClientRect();
      var max = rail.scrollWidth - rail.clientWidth;
      rail.scrollTo({ left: ((e.clientX - r.left) / r.width) * max, behavior: 'smooth' });
    });
    sync();
  }

  var grid = document.querySelector('[data-bestsellers]');
  if (grid) {
    grid.innerHTML = byPop.map(function (id, i) { return card(SQ.CATALOGUE[id], i); }).join('');
    mountRail(grid);
  }

  /* ═══════════════════════  the set builder (03)  ═══════════════════════
     The band promises "any three shapes", so the band lets you pick them.
     Grammar borrowed from the Pouchman finder: a real form, a live filter,
     and one action that produces the real result — here, three shapes in the
     cart at the set price rather than a search URL.

     Client-side because the whole catalogue is nineteen items already in
     memory; a network round trip per keystroke would be slower and worse.
     Static-first: the full list is rendered before a key is pressed, so with
     JS off you still see all nineteen and can reach every product page. */
  var setb = document.querySelector('[data-setb]');
  if (setb) (function () {
    var SLOTS = 3;
    var chosen = [];
    var band    = setb.closest('.split') || document;
    var elSlots = band.querySelector('[data-setb-slots]');
    var elList  = setb.querySelector('[data-setb-list]');
    var elQ     = setb.querySelector('[data-setb-q]');
    var elClear = setb.querySelector('[data-setb-clear]');
    var elNone  = setb.querySelector('[data-setb-none]');
    var elAxes  = setb.querySelector('[data-setb-axes]');
    var elCount = band.querySelector('[data-setb-count]');
    var elHits  = setb.querySelector('[data-setb-hits]');
    var btn     = document.querySelector('[data-add-set]');
    var hint    = document.querySelector('[data-setb-hint]');
    var feel = 'all';

    function renderSlots() {
      var out = '';
      for (var i = 0; i < SLOTS; i++) {
        var id = chosen[i];
        out += id
          ? '<button class="setb-slot is-filled" data-drop="' + i + '" ' +
            'aria-label="Remove ' + SQ.CATALOGUE[id].name + '">' +
              '<img src="' + SQ.photo(id, 1) + '" alt="">' +
              '<span class="setb-slot-x" aria-hidden="true">&#10005;</span>' +
              '<em>' + SQ.CATALOGUE[id].name.replace('The ', '') + '</em>' +
            '</button>'
          : '<span class="setb-slot"><b>' + (i + 1) + '</b></span>';
      }
      elSlots.innerHTML = out;
    }

    function renderAxes() {
      if (!elAxes) return;
      var defs = [['all', 'Any feel']].concat(Object.keys(SQ.FEELS).map(function (k) {
        return [k, SQ.FEELS[k]];
      }));
      elAxes.innerHTML = defs.map(function (d) {
        return '<button class="setb-chip" data-feel="' + d[0] + '" aria-pressed="' +
          (feel === d[0]) + '">' + d[1] + '</button>';
      }).join('');
    }

    function matches(id) {
      var p = SQ.CATALOGUE[id];
      if (feel !== 'all' && p.feel !== feel) return false;
      var q = (elQ.value || '').trim().toLowerCase();
      if (!q) return true;
      return (p.name + ' ' + p.benefit + ' ' + SQ.CATS[p.cat] + ' ' + SQ.FEELS[p.feel])
        .toLowerCase().indexOf(q) !== -1;
    }

    function renderList() {
      var hits = SQ.ALL.filter(matches);
      elList.innerHTML = hits.map(function (id) {
        var p = SQ.CATALOGUE[id];
        var on = chosen.indexOf(id) !== -1;
        return '<button class="setb-item' + (on ? ' is-on' : '') + '" data-pick="' + id + '"' +
          (on ? ' aria-pressed="true"' : ' aria-pressed="false"') + '>' +
          '<img src="' + SQ.photo(id, 1) + '" alt="" loading="lazy">' +
          (on ? '<span class="setb-item-in">In set</span>' : '') +
          '<span class="setb-item-nm">' + p.name.replace('The ', '') + '</span>' +
          '<span class="setb-item-fl">' + SQ.FEELS[p.feel] + '</span>' +
          '</button>';
      }).join('');
      /* Twentieth tile: squares off the last row (19 over 5 columns left an
         orphan, and 1-of-3 on mobile read as a failed load) and answers the
         shopper who does not want to choose. It respects the active filter. */
      if (hits.length > 1) {
        elList.insertAdjacentHTML('beforeend',
          '<button class="setb-item setb-item--any" data-any type="button">' +
          '<span class="setb-any-ico" aria-hidden="true">&#9860;</span>' +
          '<span class="setb-item-nm">Surprise me</span>' +
          '<span class="setb-item-fl">Pick one for me</span></button>');
      }
      if (elHits) elHits.textContent = hits.length === SQ.ALL.length ? '' : hits.length + ' shown';
      if (elCount) elCount.textContent = chosen.length + ' of ' + SLOTS;
      if (elNone) elNone.hidden = hits.length > 0;
      if (elClear) elClear.hidden = !(elQ.value || '').trim();
    }

    function renderCta() {
      if (!btn) return;
      var n = chosen.length;
      btn.disabled = n < SLOTS;
      btn.textContent = n < SLOTS
        ? 'Pick ' + (SLOTS - n) + ' more'
        : 'Add three · ' + SQ.fmt(SQ.UNIT * 3 - SQ.SET_DISCOUNT);
      if (hint) {
        hint.textContent = n === 0 ? 'Choose any three.'
          : n < SLOTS ? chosen.map(function (i) { return SQ.CATALOGUE[i].name.replace('The ', ''); }).join(' + ')
          : 'Saves ' + SQ.fmt(SQ.SET_DISCOUNT) + ', ships free.';
      }
    }

    function paint() { renderSlots(); renderList(); renderCta(); }

    function toggle(id) {
      var i = chosen.indexOf(id);
      if (i !== -1) chosen.splice(i, 1);
      else if (chosen.length < SLOTS) chosen.push(id);
      else { chosen.shift(); chosen.push(id); }   /* full: replace the oldest */
      paint();
    }

    elList.addEventListener('click', function (e) {
      var b = e.target.closest('[data-pick]');
      if (b) { toggle(b.getAttribute('data-pick')); return; }
      if (e.target.closest('[data-any]')) {
        var pool = SQ.ALL.filter(function (id) {
          return matches(id) && chosen.indexOf(id) === -1;
        });
        if (pool.length) toggle(pool[Math.floor(Math.random() * pool.length)]);
      }
    });
    elSlots.addEventListener('click', function (e) {
      var b = e.target.closest('[data-drop]');
      if (b) { chosen.splice(+b.getAttribute('data-drop'), 1); paint(); }
    });
    if (elAxes) elAxes.addEventListener('click', function (e) {
      var b = e.target.closest('[data-feel]'); if (!b) return;
      feel = b.getAttribute('data-feel'); renderAxes(); renderList();
    });
    elQ.addEventListener('input', renderList);
    if (elClear) elClear.addEventListener('click', function () {
      elQ.value = ''; elQ.focus(); renderList();
    });
    if (elNone) elNone.addEventListener('click', function (e) {
      if (e.target.closest('[data-setb-reset]')) {
        elQ.value = ''; feel = 'all'; renderAxes(); renderList();
      }
    });
    if (btn) btn.addEventListener('click', function () {
      if (chosen.length < SLOTS) return;
      chosen.forEach(function (id, i, a) { SQ.addItem(id, 1, i === a.length - 1); });
    });

    /* Desktop: slots and CTA sit in the sticky rail, so they stay on screen for
       the whole grid — you always see what you have picked and the button that
       changed. Mobile stacks, and there the rail would put a dead button ABOVE
       the grid, so the CTA moves into the panel and sticks to the bottom. */
    function placeCta() {
      if (!btn) return;
      var small = window.matchMedia('(max-width: 960px)').matches;
      var inPanel = btn.parentElement === setb;
      if (small && !inPanel) { setb.appendChild(btn); setb.appendChild(hint); }
      else if (!small && inPanel) {
        var pad = band.querySelector('.split-pad');
        if (pad) { pad.appendChild(btn); pad.appendChild(hint); }
      }
    }
    window.addEventListener('resize', placeCta);
    placeCta();

    /* Hand the bottom of the viewport to the builder while it is on screen —
       see the .setb-active rules. Threshold 0.35 so it releases as you leave. */
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        document.body.classList.toggle('setb-active', es[0].isIntersecting);
      }, { threshold: 0, rootMargin: '-28% 0px -28% 0px' }).observe(setb);
      /* threshold-by-ratio is wrong for a target taller than the viewport — 35%
         of a 1400px panel can never be visible on an 844px phone, so the yield
         fired only sometimes. This asks a simpler question instead: is the
         builder crossing the middle of the screen right now? */
    }

    renderAxes(); paint();
  })();

  /* ──────────────────────────  newsletter (13)  ────────────────────────── */
  var join = document.querySelector('[data-join]');
  if (join) {
    join.addEventListener('submit', function (e) {
      e.preventDefault();
      var input = join.querySelector('input');
      if (!input.value || !input.checkValidity()) { input.focus(); return; }
      /* Client-only, per the handoff. Wire to Klaviyo/Shopify on implementation. */
      join.innerHTML = '<span class="join-done">You\'re on the list</span>';
    });
  }

  /* ────────────────────────  ribbons: fill the band  ─────────────────────
     The marquee translates by -50%, so the FIRST half of the track has to be
     at least as wide as the ribbon or the tail runs empty. Measured at 1440:
     the white band's two runs covered only 62% of its 2721px width, which is
     exactly the "text doesn't come on the second part" bug. Clone each run
     until half the track covers the ribbon, and redo it on resize since the
     ribbon is sized in vw. */
  function fillRibbons() {
    document.querySelectorAll('.ribbon').forEach(function (rib) {
      var track = rib.querySelector('.ribbon-track');
      if (!track) return;
      var runs = track.querySelectorAll('.ribbon-run');
      if (!runs.length) return;

      var seed = track.getAttribute('data-seed');
      if (!seed) { seed = runs[0].outerHTML; track.setAttribute('data-seed', seed); }

      track.innerHTML = seed + seed;
      var need = rib.getBoundingClientRect().width;
      var one = track.firstElementChild.getBoundingClientRect().width;
      if (!one) return;
      var copies = Math.max(2, Math.ceil(need / one) + 1);
      /* both halves must be identical for the loop to be seamless */
      track.innerHTML = new Array(copies * 2 + 1).join(seed);
    });
  }

  var rt;
  window.addEventListener('resize', function () {
    clearTimeout(rt); rt = setTimeout(fillRibbons, 150);
  });

  /* ──────────────────────────────  boot  ───────────────────────────────── */
  fillRibbons();
  renderModes();
  renderGroups();
  if (elGroups) requestAnimationFrame(function () { elGroups.classList.add('is-in'); });
})();
